








































































































import { QUESTIONNAIRE_POP_IS_EXIST } from '@/const/storage';
import { computed, ref, onUnmounted, watch } from '@vue/composition-api';
import { DoctorInfo } from '@/components/type/type';
import OutCallPhone from './component/outCallPhone.vue';
import { getDoctorInfo, refreshDoctorInfo } from '@/utils/utils';
import { PatientDetailSourceType, MessageMode, UserType } from '@/const/business';
import Dialog from '@/views/toolsForDoctor/accountManage/components/dialog.vue';
import { DialogTypeEnum } from '@/views/toolsForDoctor/accountManage/type';
import MenuItem from './component/menuItem.vue';
import MenuSelector from './component/menuSelector.vue';
import RemindList from './component/remindList.vue';
import { MenuConfigItem } from './type';
import watermark from 'watermark-dom';
import AIDlg from './AI-assistant/index.vue';
import usePlatformCheck from '@/hooks/usePlatformCheck';

export default {
  components: {
    OutCallPhone,
    Dialog,
    MenuItem,
    MenuSelector,
    RemindList,
    AIDlg,
  },
  setup(props, { root }: any) {
    const username = ref('');
    const patientName = ref('');
    const startX = ref(0);
    const startY = ref(0);
    const innerDivXaxis = ref(0);
    const innerDivYaxis = ref(0);


    const outCallComponentShow = computed(() => root.$store.state.outCallIng);
    const doctorInfo = ref<DoctorInfo | any>({});
    const personalInfoList = computed(() =>
      [
        {
          show: true,
          name: username.value,
          routerName: 'tabTool',
          children: [
            {
              name: '账号管理',
              routerName: 'defaultToolsAccountManage',
              show: true,
            },
            {
              name: '管理员管理',
              routerName: 'defaultToolsAdminManage',
              show: doctorInfo.value.userType === 'admin',
            },
          ],
        },
      ].reduce((result, item) => {
        const { show, children } = item;
        const needShow = show && (!children || children.some((item) => item.show));
        if (!needShow) return result;
        const target = { ...item };
        if (target.children) {
          target.children = target.children.filter((item) => item.show);
        }
        result.push(target);
        return result;
      }, [] as MenuConfigItem[]),
    );

    /** 菜单核心配置 */
    const menuConfigs = computed(() => [
      {
        show: doctorInfo.value.showWorkbench === 'Y',
        name: '首页',
        routerName: 'workbench',
      },
      {
        show: doctorInfo.value.showDataPlatformTab === 'Y',
        name: '患者管理',
        routerName: 'tabPlatformData',
        children: [
          {
            name: '患者列表',
            routerName: 'defaultList',
            show: doctorInfo.value.showPatientList === 'Y',
            routeMatch: (route, nameMatch) => nameMatch && !route.query.favorite && !route.query.groupId,
          },
          {
            name: '收藏管理',
            routerName: 'defaultList',
            show: true,
            routeMatch: (route, nameMatch) => nameMatch && route.query.favorite === '1',
            query: {
              favorite: '1',
            },
          },
          {
            name: '分组管理',
            routerName: 'defaultGroup',
            show: true,
            routeMatch: (route, nameMatch) => {
              const { name, query } = route;
              return !!(nameMatch || (name === 'defaultList' && query.groupId));
            },
          },
          {
            name: '标签管理',
            show: doctorInfo.value.showTagManage === 'Y',
            routerName: 'defaultTagManage',
          },
        ],
      },
      {
        show:
          doctorInfo.value.showFollowUpTab === 'Y' ||
          doctorInfo.value.showAfterDiagnosisPlan === 'Y' ||
          doctorInfo.value.showSmartForm === 'Y',
        name: '项目管理',
        routerName: 'tabProjectManage',
        children: [
          {
            show: doctorInfo.value.showFollowUpTab === 'Y',
            name: '智能随访',
            routerName: 'defaultIntelligentFollowUpList',
            routeMatch: (route, nameMatch) =>
              (nameMatch || route.query.origin === PatientDetailSourceType.followUpPlan) &&
              !route.fullPath.includes('templateManage'),
          },
          {
            name: '诊后管理',
            routerName: 'defaultDiagnosisPlan',
            show: doctorInfo.value.showAfterDiagnosisPlan === 'Y',
          },
          {
            name: '智能表单',
            routerName: 'defaultToolsForDoctor',
            show: doctorInfo.value.showSmartForm === 'Y',
            routeMatch: (route, nameMatch) => nameMatch || route.query.origin === PatientDetailSourceType.issueForm,
          },
          {
            name: '模板管理',
            routerName: 'defaultTemplateManage',
            show: true,
          },
        ],
      },
      {
        show: doctorInfo.value.showDataPlatformTab === 'Y',
        name: '消息沟通',
        routerName: 'tabMessageCommunicate',
        children: [
          {
            name: '患者消息群发',
            routerName: 'defaultMessage',
            show: doctorInfo.value.canSendMsg === 'Y',
            routeMatch: (route, routeMatch) => routeMatch && !route.query.busiType,
          },
          {
            name: '消息自动回复',
            routerName: 'autoReplyList',
            show: doctorInfo.value.showAutoReply === 'Y',
          },
          {
            name: '生成通知提醒',
            routerName: 'defaultMessage',
            show: doctorInfo.value.canCreateMsg === 'Y',
            routeMatch: (route, nameMatch) => nameMatch && route.query.busiType === MessageMode.generateMessage,
            query: {
              busiType: MessageMode.generateMessage,
            },
          },

          {
            name: '短信下发管理',
            routerName: 'defaultMessage',
            show: doctorInfo.value.showSendSMS === 'Y',
            routeMatch: (route, nameMatch) => nameMatch && route.query.busiType === MessageMode.SMSMessage,
            query: {
              busiType: MessageMode.SMSMessage,
            },
          },
          {
            name: '消息模板管理',
            routerName: 'defaultMsgTemplateManage',
            show: true,
          },
          {
            name: '聚合页',
            routerName: 'aggregationPageIndex',
            show: doctorInfo.value.showAggregationPage === 'Y',
          },
        ],
      },
      {
        show: doctorInfo.value.showInHospitalTool === 'Y',
        name: '院内模块',
        routerName: 'inHospitalTabTool',
        children: [
          {
            name: '院内患者列表',
            routerName: 'defaultToolsInHospitalList',
            show: true,
          },
          {
            name: '院内分组管理',
            routerName: 'defaultToolsInHospitalGroup',
            show: true,
          },
          {
            name: '院内收藏管理',
            routerName: 'defaultToolsInHospitalListSpecial',
            show: true,
          },
          {
            name: '院内消息下发',
            routerName: 'defaultToolsInHospitalMessage',
            show: true,
          },
        ],
      },
      {
        show: doctorInfo.value.showJiayiModule === 'Y',
        name: '家医模块',
        routerName: 'familyDoctorTabTool',
        children: [
          {
            name: '签约居民列表',
            routerName: 'defaultFamilyDoctorList',
            show: true,
          },
          {
            name: '家医分组管理',
            routerName: 'defaultFamilyDoctorGroup',
            show: true,
          },
          {
            name: '家医收藏管理',
            routerName: 'defaultFamilyDoctorFavorite',
            show: true,
          },
          {
            name: '家医消息下发',
            routerName: 'defaultFamilyDoctorMessage',
            show: true,
          },
        ],
      },
      {
        show: doctorInfo.value.showSpecialDisease === 'Y',
        name: '科研工具',
        routerName: 'tabScientificTools',
        children: [
          {
            name: '智能专病库',
            routerName: 'specialDiseaseLibrary',
            show: true,
          },
        ],
      },
      {
        show: doctorInfo.value.showPatientRecruitTab === 'Y',
        name: '临床招募',
        routerName: 'tabPatientRecruit',
        children: [
          {
            name: '试验报名',
            routerName: 'defaultTestPatient',
            show: true,
            // eslint-disable-next-line max-len
            routeMatch: (route, nameMatch) =>
              nameMatch || route.query.origin === PatientDetailSourceType.testRegistration,
          },
          {
            name: '意向登记',
            routerName: 'defaultIntentRegister',
            show: true,
            // eslint-disable-next-line max-len
            routeMatch: (route, nameMatch) =>
              nameMatch || route.query.origin === PatientDetailSourceType.intentToRegister,
          },
          {
            name: '项目管理',
            routerName: 'recruitmentManagement',
            show: true,
          },
          {
            name: '数据统计',
            routerName: 'recruitmentDataStatistics',
            show: true,
          },
        ],
      },
      {
        show: doctorInfo.value.showConfigStatistics === 'Y',
        name: '配置和统计',
        routerName: 'tabConfigStatistics',
        children: [
          {
            name: '精准预约统计',
            routerName: 'preciseStatistics',
            show: doctorInfo.value.showPreciseStatistics === 'Y',
          },
          {
            name: '智能问答配置',
            routerName: 'qaConfig',
            show: doctorInfo.value.showQaConfig === 'Y',
          },
          {
            name: '智能问答统计',
            routerName: 'qaStatistics',
            show: doctorInfo.value.showQaStatistics === 'Y',
          },
          {
            name: '平台统计数据',
            routerName: 'statisticalData',
            show: doctorInfo.value.shwoJoinFollowUpStatisticsData === 'Y',
          },
          {
            name: '平台看板',
            routerName: 'platformBoard',
            show: doctorInfo.value.showPlatformDashboard === 'Y',
          },
        ],
      },
      {
        show: doctorInfo.value.showPrepareVisit === 'Y',
        name: '智能预问诊',
        routerName: 'preInquiryDetail',
        routeMatch: (route, nameMatch) => nameMatch || route.query.origin === PatientDetailSourceType.prepareVisit,
      },
    ]);

    /** 展示的菜单，用于渲染 */
    const showedMenuConfig = computed(() =>
      (menuConfigs.value as any).reduce((result, item) => {
        const { show, children } = item;
        const needShow = show && (!children || children.some((item) => item.show));
        if (!needShow) return result;
        const target = { ...item };
        if (target.children) {
          target.children = target.children.filter((item) => item.show);
        }
        result.push(target);
        return result;
      }, [] as MenuConfigItem[]),
    );

    /** 处理通用的菜单点击 */
    const fnMenuClick = (menu: MenuConfigItem) => {
      const { routerName, query } = menu;
      root.$router.push({
        name: routerName,
        query: {
          ...query,
          timeStamp: `${new Date().getTime()}`,
        },
      });
    };

    const showHeader = computed(() => root.$store.state.showHeader);
    const isKeepAlive = computed(() => root.$route.meta.keepAlive);

    const setSearchCondition = (params) => {
      root.$store.commit('SET_SEARCH_CONDITION', params);
    };

    const logout = async () => {
      const { err } = await root.$http.post('/hospital/logout', {});
      if (err) {
        throw new Error('弹窗拦截');
      }
      root.$router.replace({
        path: '/login',
      });
      // 清除(协和罕见病数据登录提示+问卷调查)标记
      localStorage.removeItem(QUESTIONNAIRE_POP_IS_EXIST);
    };

    const search = () => {
      const patientNameValue = patientName.value;
      if (!patientNameValue) {
        alert('请输入搜索内容');
        return;
      }
      setSearchCondition(patientNameValue);
      root.$router.push({
        path: `/default/list?key=${encodeURIComponent(patientNameValue)}${new Date().valueOf()}`,
      });
    };
    const isTestEnv = process.env.VUE_APP_ENV === 'test';
    const isJiayi = ref(false);
    let sumUnreadTimeer = 0;
    const init = async () => {
      let doctorInfoValue = await getDoctorInfo();
      isJiayi.value = doctorInfoValue?.organType === 3;
      root.$store.commit('SET_ORGANTYPE', doctorInfoValue?.organType);
      const rsp = await refreshDoctorInfo();
      if ([UserType.main, UserType.normal].includes(rsp?.userType) && rsp?.waitingCount) {
        showDialog(DialogTypeEnum.bindTips, rsp);
      } else if (rsp?.userType === UserType.sub && rsp?.unBindRemind) {
        showDialog(DialogTypeEnum.unBindTips);
      }
      doctorInfoValue = rsp;
      console.log('doctorInfo', doctorInfoValue);
      isJiayi.value = doctorInfoValue?.organType === 3;
      root.$store.commit('SET_ORGANTYPE', doctorInfoValue?.organType);

      doctorInfo.value = doctorInfoValue;
      watermark.init({
        watermark_txt: `${doctorInfoValue.hospitalName}_${doctorInfoValue.departmentName}_${doctorInfoValue.doctor_name}`,
        watermark_width: 360,
        watermark_alpha: 0.1,
      });
      username.value = doctorInfoValue.doctor_name;
      if (doctorInfo.value.showGroupChat === 'Y') {
        getSumUnread();
        // 测试环境改成30秒轮询一次
        const intervalTime = isTestEnv ? 6000 * 10 : 10000;
        sumUnreadTimeer = setInterval(() => {
          getSumUnread();
        }, intervalTime);
      }
    };

    const getSumUnread = async () => {
      const data = await root.$http.post('/hospital/getSumUnread', {});
      if (!data.err) {
        sumUnread.value = data?.sumUnread;
        root.$store.commit('SET_REMINDSUM', sumUnread.value);
      }
    };

    const drag = (x, y) => {
      // 计算鼠标点击位置div内的偏移量
      innerDivXaxis.value = x;
      innerDivYaxis.value = y;
    };

    const drop = ($event) => {
      const divCallPhone: HTMLElement = document.querySelector('.fix-out-call') as HTMLElement;
      if (!divCallPhone) return;
      startX.value = $event.x;
      startY.value = $event.y;
      const clientX = window.screen.availWidth;
      const clientY = window.screen.availHeight;
      const xChange = clientX - startX.value - innerDivXaxis.value;
      // Y方向内容
      const yChange = clientY - startY.value - 112 - innerDivYaxis.value;

      if (clientX - xChange < 170) {
        divCallPhone.style.right = `${clientX - startX.value - innerDivXaxis.value - (170 - (clientX - xChange))}px`; // 16 - 16
      } else if (xChange < 0 && xChange > -170) {
        divCallPhone.style.right = `${clientX - startX.value - innerDivXaxis.value - xChange}px`; // 16 - 16
      } else {
        divCallPhone.style.right = `${clientX - startX.value - innerDivXaxis.value}px`; // 16 - 16
      }

      if (yChange > -128 && yChange < 0) {
        divCallPhone.style.bottom = `${clientY - startY.value - 112 - innerDivYaxis.value - yChange}px`; // 128 - 16
      } else if (clientY - yChange < 240) {
        divCallPhone.style.bottom = `${
          clientY - startY.value - 112 - innerDivYaxis.value - (240 - (clientY - yChange))
        }px`; // 128 - 16
      } else {
        divCallPhone.style.bottom = `${clientY - startY.value - 112 - innerDivYaxis.value}px`; // 128 - 16
      }
    };

    onUnmounted(() => {
      root.$store.commit('SET_CURRENT_OUT_CALL_PATIENT', '');
      root.$store.commit('SET_OUT_CALL_ROUTER', {});
      root.$store.commit('SET_OUT_CALLING', false);
      root.$store.commit('SET_OUT_CALL_COMPONENT_SHOW', false);
      root.$store.commit('SET_SEARCH_CONDITION', '');
      clearInterval(sumUnreadTimeer);
    });

    watch(
      () => [root.$store.state.patientName, root.$route],
      ([newName]) => {
        if (!newName) {
          patientName.value = '';
        }
      },
    );
    const sumUnread = ref(0);
    init();
    const dialogSwitchFlag = ref(false);
    const dialogContent = ref({});
    const dialogType = ref('');
    const showDialog = (type, content = {}) => {
      dialogContent.value = content;
      dialogType.value = type;
      dialogSwitchFlag.value = true;
    };
    const cancelDialogCB = () => {
      dialogSwitchFlag.value = false;
    };
    const confirmDialogCB = () => {
      dialogSwitchFlag.value = false;
    };
    const popoverRef = ref<any>(null);
    const remindClose = () => {
      popoverRef.value.doClose();
    };
    const remindListRef = ref<any>(null);
    const refererRemindList = () => {
      console.log(remindListRef.value);
      remindListRef.value.getCommunicateList();
    };

    const isAIShow = computed(
      () =>
        doctorInfo.value.aiAssistant === 'Y' &&
        (doctorInfo.value.aiEducationAssistant === 'Y' ||
          doctorInfo.value.aiPlanAssistant === 'Y' ||
          doctorInfo.value.aiSummaryAssistant === 'Y' ||
          doctorInfo.value.aiPatientArchiveChatAssistant === 'Y'),
    );
    const AIDlgVisible = ref(false);

    const { isQiWei } = usePlatformCheck();

    return {
      projectName: root.$global.projectName,
      username,
      patientName,
      showHeader,
      doctorInfo,
      outCallComponentShow,
      PatientDetailSourceType,
      setSearchCondition,
      logout,
      search,
      drag,
      drop,
      isKeepAlive,
      cancelDialogCB,
      confirmDialogCB,
      dialogSwitchFlag,
      dialogType,
      dialogContent,
      showedMenuConfig,
      fnMenuClick,
      personalInfoList,
      remindClose,
      popoverRef,
      remindListRef,
      sumUnread,
      refererRemindList,
      isJiayi,
      isAIShow,
      AIDlgVisible,
      isQiWei,
    };
  },
};
